module.exports = __webpack_public_path__ + "img/ANTENNA 1 BW.593052d.svg";